import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../createAppAsyncThunk';
import { API_POST } from '../../services';
import { HigherGroundStatusModel } from '../../models/HigherGroundStatusModel';
import { RADRequest } from '../../models/common/RADRequest';
import type { RootState } from '../store';
import { env } from '../../env';
import { ENDPOINTS } from '../../constants/endPoints';

interface HigherGroundStatusState {
  higherGroundStatus: HigherGroundStatusModel | null;
  isLoading: boolean;
}

const initialState: HigherGroundStatusState = {
  higherGroundStatus: null,
  isLoading: false,
};

export const fetchHigherGroundStatus = createAppAsyncThunk(
  'higherGroundStatus/fetchStatus',
  async (params: RADRequest) => {
    const payload = {
      storeNumber: params.storeNumber,
      isMultiStoreMode: params.isMultiStoreMode ?? false,
    };

    const response = await API_POST(
      `${env.RAD_APP_API_URL}${ENDPOINTS.GET_HIGHER_GROUND_STATUS}`,
      payload,
    );
    return response as HigherGroundStatusModel;
  },
);

const higherGroundStatusSlice = createSlice({
  name: 'higherGroundStatus',
  initialState,
  reducers: {
    clearHigherGroundStatus: state => {
      state.higherGroundStatus = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchHigherGroundStatus.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchHigherGroundStatus.fulfilled, (state, action) => {
        state.higherGroundStatus = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchHigherGroundStatus.rejected, state => {
        state.higherGroundStatus = null;
        state.isLoading = false;
      });
  },
});

export const { clearHigherGroundStatus } = higherGroundStatusSlice.actions;

// Selectors
export const selectHigherGroundStatus = (state: RootState) => state.higherGroundStatus.higherGroundStatus;
export const selectHigherGroundStatusLoading = (state: RootState) => state.higherGroundStatus.isLoading;

export default higherGroundStatusSlice.reducer;
